module.exports = __webpack_public_path__ + "static/media/IMG_3336-min.5e68b293.JPG";